"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselNavigation,
} from "@/components/ui/carousel";
import { RewardCard } from "@/components/reward-card";

const REWARDS = [
  {
    img: "/icons/bitcoin.svg",
    cryptoSymbol: "BTC",
    cryptoBalance: 0.082,
    usdBalance: 800.25,
  },
  {
    img: "/icons/avalanche.svg",
    cryptoSymbol: "AVAX",
    cryptoBalance: 10.5,
    usdBalance: 357.5,
  },
  {
    img: "/icons/dogecoin.svg",
    cryptoSymbol: "DOGE",
    cryptoBalance: 1250,
    usdBalance: 543.75,
  },
  {
    img: "/icons/ethereum.svg",
    cryptoSymbol: "ETH",
    cryptoBalance: 0.45,
    usdBalance: 1530,
  },
  {
    img: "/icons/cardano.svg",
    cryptoSymbol: "ADA",
    cryptoBalance: 20,
    usdBalance: 21.8,
  },
];

export function RewardsCarousel() {
  return (
    <Carousel
      opts={{
        align: "start",
      }}
      className="w-full"
    >
      <CarouselContent>
        {REWARDS.map((balance, index) => (
          <CarouselItem key={index} className="xs:basis-1/2 lg:basis-[33.33%]">
            <RewardCard {...balance} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="mt-6 flex items-center justify-between gap-6">
        <CarouselNavigation />
        <div className="flex items-center gap-1">
          <CarouselPrevious
            className="relative left-0 size-6 translate-x-0 translate-y-0 [&_svg]:size-3"
            aria-label="Previous slide"
          />
          <CarouselNext
            className="relative left-0 size-6 translate-x-0 translate-y-0 [&_svg]:size-3"
            aria-label="Next slide"
          />
        </div>
      </div>
    </Carousel>
  );
}
